/*
	Base para reduzir animações e movimentos globalmente
*/
export default ({ commit }, reduced=true ) => 
	commit("setReducedMotion", reduced)

